import {axiosInstance, publicAxiosInstance} from "../utils/axios";

export const addStudents = ({classId, students}) => {
    if (!classId || !students || !Array.isArray(students))
        return;

    return axiosInstance.post(`teachers/virtual-class/${classId}/add/students`, students);
};

export const getAllStudentsOfVirtualClass = (classId) => {
    if (!classId)
        return;

    return axiosInstance.get(`teachers/virtual-class/${classId}/students`);
};

export const getAllStudentsOfVirtualClassRTQ = ({queryKey}) => {
    if (!queryKey[1].classId)
        return;

    return getAllStudentsOfVirtualClass(queryKey[1].classId);
}

const getAllStudentByClassId = async (classId) => {
    return await axiosInstance.get(`/teachers/virtual-class/${classId}/students`)
}

export const getStudentByclassIdRTQ = async ({queryKey}) => {
    if (!queryKey[1].classId)
        return;

    const res = await getAllStudentByClassId(queryKey[1].classId);

    return res;
}

export const inviteStudents = ({classId, students}) => {
    if (!students || !Array.isArray(students) || !classId)
        return;

    return axiosInstance.post(`teachers/invite/students/${classId}`, students);
}

export const acceptInvitation = ({invitationCode}) => {
    if (!invitationCode || typeof invitationCode !== "string")
        return;

    return publicAxiosInstance.post(`users/confirm`, invitationCode);
}

export const getStudentDetail = ({queryKey}) => {
    if (!queryKey[1].studentId)
        return;

    return axiosInstance.get(`/users/confirm`)
}

export const completeProfile = ({id, data}) => {
    if (!id || !data)
        return;

    return publicAxiosInstance.post(`users/student/${id}`, data)
}

export const updateStudentProfile = ({id, data}) => {
    if (!id || !data)
        return;

    return axiosInstance.put(`students/${id}`, data)
}
